module.exports = __webpack_public_path__ + "static/img/ADELAIDE.b71e5bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ADELAIDE.svg
// module id = odBq
// module chunks = 0